import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <path
      d="M9.84776 3.23463C10 3.60218 10 4.06812 10 5V19C10 19.9319 10 20.3978 9.84776 20.7654C9.64477 21.2554 9.25542 21.6448 8.76537 21.8478C8.39783 22 7.93188 22 7 22H6C5.06812 22 4.60218 22 4.23463 21.8478C3.74458 21.6448 3.35523 21.2554 3.15224 20.7654C3 20.3978 3 19.9319 3 19V5C3 4.06812 3 3.60218 3.15224 3.23463C3.35523 2.74458 3.74458 2.35523 4.23463 2.15224C4.60218 2 5.06812 2 6 2H7C7.93188 2 8.39783 2 8.76537 2.15224C9.25542 2.35523 9.64477 2.74458 9.84776 3.23463Z"
      fill="inherit"
    />
    <path
      d="M20.8478 3.23463C21 3.60218 21 4.06812 21 5V19C21 19.9319 21 20.3978 20.8478 20.7654C20.6448 21.2554 20.2554 21.6448 19.7654 21.8478C19.3978 22 18.9319 22 18 22H17C16.0681 22 15.6022 22 15.2346 21.8478C14.7446 21.6448 14.3552 21.2554 14.1522 20.7654C14 20.3978 14 19.9319 14 19V5C14 4.06812 14 3.60218 14.1522 3.23463C14.3552 2.74458 14.7446 2.35523 15.2346 2.15224C15.6022 2 16.0681 2 17 2H18C18.9319 2 19.3978 2 19.7654 2.15224C20.2554 2.35523 20.6448 2.74458 20.8478 3.23463Z"
      fill="inherit"
    />
  </>,
  'PauseFillIcon',
)
